/**
 * recipientLevel — the shared contact-LEVEL vocabulary for an information request.
 *
 * A contact reachable for a request is attached at one of three levels of the
 * client → property → parcel hierarchy. Both the New-information-request modal
 * (which lets the user pick recipients by level) and the request profile (which
 * shows the level(s) actually delivered to, beside "Sent to") render the SAME
 * wording from here — matching the contacts-tab labels on client profiles
 * (ClientContactsGrouped) so the recipient scope reads identically across the app.
 * Single source of truth: never hardcode these strings at a call site.
 */

export type RecipientLevel = 'client' | 'property' | 'parcel';

export const LEVEL_LABEL: Record<RecipientLevel, string> = {
  client: 'Client level',
  property: 'Property level',
  parcel: 'Parcel level',
};

/** Broadest → narrowest — the stable order levels are displayed in. */
export const LEVEL_ORDER: RecipientLevel[] = ['client', 'property', 'parcel'];
